import React, { Dispatch, useState } from 'react';
import { AuthenticationInfo, AuthenticationInfoHeader, LogoWrapper } from 'components/authentication/styled';
import MadlanLogoIcon from 'assets/svg/il-logo-small.svg';
import AuthSocialsButtons from 'components/authentication/social-buttons';
import { AuthenticationEmailForm } from 'components/authentication/AuthenticationEmailForm';
import { noop } from 'lodash';
import { useLocale } from 'locale';
import { AuthenticationField } from 'components/authentication/types';
import { authEmailSelector } from 'store/state/app/selectors';
import { RootAction, State } from 'store/state';
import { setAuthEmail, signInSignUpWithEmail } from 'store/state/app/actions';
import { connect } from 'react-redux';
import { isEmailValid as isEmailValidHelper } from 'utils/formValidationHelpers';
import { ISignInSignUpWithEmailVariables, MutationResponseByType, MutationType } from 'store/sagas/apiService/types';
import { signInSignUpLoadingSelector } from 'store/state/mutationsResponse/selectors';
import { ApolloQueryResult } from 'apollo-client';
import { LoginContentWrapper } from 'screens/Investors/Login/styled';


interface AuthProps {
  email: string;
  setEmail: (email: string) => void;
  onSignInSignUpWithEmail: (data: ISignInSignUpWithEmailVariables) => void;
  signInSignUpLoading?: ApolloQueryResult<MutationResponseByType[MutationType.SignInSignUpWithEmail]>;
}

const LoginFormBase: React.FC<AuthProps> = (props) => {
  const {
    email,
    setEmail,
    onSignInSignUpWithEmail,
    signInSignUpLoading,
  } = props;
  const { t } = useLocale();
  const infoText = t('investors.authenticationInfo', { type: null });

  const [ dirty, setDirty ] = useState(new Set<AuthenticationField>([]));

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.currentTarget.value);
  const handleSetDirty = (field: AuthenticationField) => setDirty(prev => new Set([ ...prev, field ]));
  const handleSignInSignUpSubmit = () => {
    if (email && isEmailValid) {
      onSignInSignUpWithEmail({ email: email.toLowerCase() });
    }
    else {
      handleSetDirty('email');
    }
  };

  const isEmailValid = email && isEmailValidHelper(email);

  return (
    <LoginContentWrapper>
      <LogoWrapper>
        <MadlanLogoIcon height={58} width={64} />
      </LogoWrapper>
      <AuthenticationInfoHeader weight="bold">
        {t('investors.authenticationInfo.header')}
      </AuthenticationInfoHeader>
      <AuthenticationInfo>{infoText}</AuthenticationInfo>
      <AuthenticationEmailForm
        onSetDirty={handleSetDirty}
        email={email}
        submitText={t('authentication.authenticationEmailSubmitLabel')}
        isEmailValid={isEmailValid}
        dirtyFields={dirty}
        onEmailChange={handleEmailChange}
        onSubmit={handleSignInSignUpSubmit}
        isLoading={signInSignUpLoading ? signInSignUpLoading.loading : false}
        fullWidth
      />
      <AuthSocialsButtons
        onSocialLogin={noop}
        withSuggestionBefore
        fullSize
      />
    </LoginContentWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  email: authEmailSelector(state),
  signInSignUpLoading: signInSignUpLoadingSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  setEmail: (email: string) => dispatch(setAuthEmail(email)),
  onSignInSignUpWithEmail: (data: ISignInSignUpWithEmailVariables) => dispatch(signInSignUpWithEmail(data)),
});

export const LoginForm = connect(mapStateToProps, mapDispatchToProps)(LoginFormBase);
